import { render } from "./ModalPublishStatus.vue?vue&type=template&id=5bdda128"
import script from "./ModalPublishStatus.vue?vue&type=script&lang=js"
export * from "./ModalPublishStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__